import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-button-shadow',
  templateUrl: './button-shadow.component.html',
  styleUrls: ['./button-shadow.component.scss']
})
export class ButtonShadowComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
